/** The QC pages' chunks — the routes' `lazy()` calls these, so a preload warms the same import. */
export const loadQcSetupPage = () => import('../../pages/qc-setup-page');
export const loadQcRunPage = () => import('../../pages/qc-run-page');

/**
 * Starts downloading every QC page chunk on hover/focus intent, so the click renders at once.
 * A failed preload is ignored: the route's own `lazy()` retries and shows its error boundary.
 */
export function preloadQcPages(): void {
  for (const load of [loadQcSetupPage, loadQcRunPage]) {
    load().catch(() => undefined);
  }
}
